import {
  LogOut,
  Pin,
  PinOff,
  X,
} from "lucide-react";
import {
  navigationLabel,
} from "../shared/auth/access";
import type { useApplicationShell } from "./useApplicationShell";
import { platformBrand } from "../shared/branding";

export function AppSidebar({ model }: { model: ReturnType<typeof useApplicationShell> ;}) {
  const { user, sidebarOpen, setSidebarOpen, sidebarPinned, activeNav, navigateTo, sidebarPrimaryItems, sidebarSecondaryItems, closeSidebarAfterPointerLeave, closeSidebar, toggleSidebarPin, logout } = model;
  return (<aside
    className={`sidebar ${sidebarOpen || sidebarPinned ? "sidebar-open" : ""}`}
    onMouseEnter={() => setSidebarOpen(true)}
    onMouseLeave={closeSidebarAfterPointerLeave}
  >
    <div className="brand">
      <img className="brand-logo" src="/anl-logo-new-2026.webp" alt="ANL" />
      <div>
        <strong>{platformBrand.name}</strong>
        <small>{platformBrand.description}</small>
      </div>
      <div className="sidebar-controls">
        <button
          className="sidebar-pin"
          onClick={toggleSidebarPin}
          aria-label={
            sidebarPinned ? "Menü sabitlemesini kaldır" : "Menüyü sabitle"
          }
          aria-pressed={sidebarPinned}
          title={sidebarPinned ? "Sabitlemeyi kaldır" : "Menüyü sabitle"}
        >
          {sidebarPinned ? <PinOff size={16} /> : <Pin size={16} />}
        </button>
        <button
          className="sidebar-close"
          onClick={closeSidebar}
          aria-label="Menüyü kapat"
          title="Menüyü kapat"
        >
          <X size={18} />
        </button>
      </div>
    </div>

    <nav aria-label="Ana menü">
      {user.role !== "SISTEM_YONETICISI" ? (
        <span className="nav-label">
          {user.role === "KALITE_UZMANI" || user.role === "KALITE_MUDURU"
            ? "Kalite"
            : user.role === "TEKNIK_MUDURU"
              ? "Teknik"
              : user.role === "URETIM_OPERATORU" || user.role === "VARDIYA_AMIRI" || user.role === "URETIM_YONETICISI"
                ? "Üretim"
                : "Satın Alma"}
        </span>
      ) : null}
      {sidebarPrimaryItems.map((item) => {
        const Icon = item.icon;
        return (
          <button
            key={item.label}
            className={activeNav === item.label ? "active" : ""}
            onClick={() => {
              navigateTo(item.label);
              if (!sidebarPinned) setSidebarOpen(false);
            }}
          >
            <Icon size={18} strokeWidth={1.8} />
            <span>{navigationLabel(user, item.label)}</span>
          </button>
        );
      })}
    </nav>

    <div className="sidebar-spacer" />

    <div className="nav-secondary">
      {sidebarSecondaryItems.map((item) => {
        const Icon = item.icon;
        return (
          <button
            key={item.label}
            className={activeNav === item.label ? "active" : ""}
            onClick={() => {
              navigateTo(item.label);
              if (!sidebarPinned) setSidebarOpen(false);
            }}
          >
            <Icon size={18} />
            <span>{navigationLabel(user, item.label)}</span>
          </button>
        );
      })}
    </div>

    <div className="user-card">
      <div className="user-avatar">{user.initials}</div>
      <div>
        <strong>{user.name}</strong>
        <small>
          {user.roleLabel} · {user.department}
        </small>
      </div>
      <button
        className="user-scope"
        title="Oturumu kapat"
        aria-label="Oturumu kapat"
        onClick={() => void logout()}
      >
        <LogOut size={15} />
      </button>
    </div>
  </aside>);
}
